import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

export default withStyles(() => ({
  root: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}))(Toolbar);
